import { CURRENT_SONNET_MODEL } from './model.js';
/**
 * Owner policy ccfe38ba, 2026-10-26: Codex sem preferencia abre no Terra vigente/max, codigo incluido.
 * A geracao e resolvida na abertura (model-lifecycle). Preferencias, pins e continuidade explicitos
 * permanecem soberanos; defaults nunca reescrevem uma escolha humana gravada ou um processo vivo.
 */
export const PROJECT_CODEX_MODEL = 'gpt-6.1-terra';
export const PROJECT_CODEX_EFFORT = 'max';
/**
 * 28/10/2026 — Claude de projeto sem preferência: Sonnet vigente em esforço alto (política por risco do dono, 08/10 #300:
 * "pra projetos de menor risco, quando for utilizar Claude, acaba sendo preferencial utilizar o Sonnet 5.5, esforço alto";
 * "projetos de maior risco, aí continua o Opus 5.5"). Projeto de alto risco ou prioridade fixa o Opus pela preferência
 * do próprio projeto. Só o MASTER segue em `CURRENT_OPUS_MODEL`; runners e o slot do Produto abrem no Sonnet vigente
 * (ed3018fe, dono 31/10: Opus só com justificativa explícita).
 */
export const PROJECT_CLAUDE_MODEL = CURRENT_SONNET_MODEL;
export const PROJECT_CLAUDE_EFFORT = 'high';
/** Only a verified model-specific cap authorizes this fallback. Provider quota is a different fact.
 * Applied at launch boundaries; does not mutate preferences or touch an existing process. */
export function resolveClaudeModelCap(input) {
    if (input.model?.startsWith('claude-fable-') &&
        input.cappedModels.has(input.model) &&
        !input.cappedModels.has(CURRENT_SONNET_MODEL)) {
        // ed3018fe (dono, 31/10): o fallback automático nunca escolhe Opus; cai no Sonnet vigente em alto.
        return {
            model: CURRENT_SONNET_MODEL,
            effort: 'high',
            reason: 'fable_model_cap',
        };
    }
    return { model: input.model, effort: input.effort, reason: null };
}
//# sourceMappingURL=launch-model-policy.js.map